import React, { useEffect, useState, useContext } from 'react';
import { ConsultaPermissoes, SalvaPermissoes } from '../../lib/api';
import { GlobalContext } from '../../lib/GlobalVar';
import Swal from 'sweetalert2';

// [iter5] BUG 5: matriz tinha 4 problemas:
//   (a) setMat(resp) salvava { telas, setores, matriz } inteiro em vez de só resp.matriz
//   (b) toggle usava next[tela][setor] mas o shape do backend é { setor: { telaId: bool } }
//   (c) TELAS hard-coded com IDs diferentes do backend ("Crontab Visual" vs "Crontab")
//   (d) SETORES com/sem acento divergindo do backend
// Solução: derivar TELAS e SETORES da resposta do backend, salvar apenas matriz, toggle correto.

export default function TIPermissoes() {
    const { user: me } = useContext(GlobalContext);
    const [telas, setTelas] = useState([]);
    const [setores, setSetores] = useState([]);
    const [matriz, setMatriz] = useState({});
    const [salvando, setSalvando] = useState(false);

    useEffect(() => { carregar(); }, []);

    async function carregar() {
        const resp = await ConsultaPermissoes({});
        if (resp.Error) return Swal.fire({ icon: 'warning', title: 'Atenção', text: resp.Error });
        setTelas(Array.isArray(resp.telas) ? resp.telas : []);
        setSetores(Array.isArray(resp.setores) ? resp.setores : []);
        setMatriz(resp.matriz || {});
    }

    function toggle(setor, telaId, locked) {
        if (locked) return; // telas TI travadas: nao deixa toggle (exceto setor TI que ja vem true do backend)
        setMatriz(prev => ({
            ...prev,
            [setor]: {
                ...(prev[setor] || {}),
                [telaId]: !prev[setor]?.[telaId]
            }
        }));
    }

    async function salvar() {
        setSalvando(true);
        const resp = await SalvaPermissoes({ solicitante: me?.email, matriz });
        setSalvando(false);
        if (resp.Error) return Swal.fire({ icon: 'warning', title: 'Atenção', text: resp.Error });
        // [bug7] dispara evento para invalidar cache de permissoes em App.jsx e re-checar Sidebar
        try { window.dispatchEvent(new Event('centralbabita:permissoes-atualizadas')); } catch (e) {}
        Swal.fire({ icon: 'success', title: 'Matriz salva', timer: 1200, showConfirmButton: false });
        carregar();
    }

    const telasTI = telas.filter(t => t.locked).length;
    const telasOp = telas.length - telasTI;

    return (
        <div className="page">
            <div className="page-head">
                <div>
                    <div className="eyebrow"><span className="num ti">TI</span> Permissões de Telas</div>
                    <h1 className="page-title">Permissões de Telas</h1>
                    <p className="page-sub">Matriz tela × setor. Telas TI · Restrito são travadas (ícone de cadeado) e nunca podem ser liberadas para outros setores.</p>
                </div>
                <button className="btn" disabled={salvando} onClick={salvar}>
                    {salvando ? 'Salvando…' : 'Salvar matriz'}
                </button>
            </div>

            <div className="kpi-strip">
                <div className="kpi-cell"><div className="kpi-label">Telas registradas</div><div className="kpi-val">{telas.length}</div></div>
                <div className="kpi-cell"><div className="kpi-label">Setores</div><div className="kpi-val">{setores.length}</div></div>
                <div className="kpi-cell"><div className="kpi-label">Telas TI exclusivas</div><div className="kpi-val">{telasTI}</div></div>
                <div className="kpi-cell"><div className="kpi-label">Operação livre</div><div className="kpi-val">{telasOp}</div></div>
            </div>

            {telas.length === 0 && <div className="muted" style={{ padding: 24 }}>Carregando matriz…</div>}

            {telas.length > 0 && (
                <div className="card flat" style={{ padding: 0, overflowX: 'auto' }}>
                    <table className="perm-matrix">
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left' }}>Tela</th>
                                {setores.map(s => <th key={s}>{s.toUpperCase()}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {telas.map(t => (
                                <tr key={t.id}>
                                    <td className="label">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            {t.locked && <span style={{ color: 'var(--ink-mute)' }}>🔒</span>}
                                            <div>
                                                <div>{t.l || t.id}</div>
                                                <div className="mono muted" style={{ fontSize: 11 }}>/{t.id}</div>
                                            </div>
                                        </div>
                                    </td>
                                    {setores.map(s => {
                                        const ativo = !!matriz[s]?.[t.id];
                                        const disabled = !!(t.locked && s !== 'TI');
                                        return (
                                            <td key={s} onClick={() => toggle(s, t.id, t.locked)} style={{ cursor: disabled ? 'not-allowed' : 'pointer', textAlign: 'center' }}>
                                                <div title={disabled ? 'Travada (TI restrito)' : (ativo ? 'Liberada' : 'Bloqueada')}
                                                     style={{
                                                        width: 18, height: 18, margin: '0 auto', borderRadius: '50%',
                                                        border: '1px solid var(--ink)',
                                                        background: ativo ? 'var(--ink)' : 'transparent',
                                                        opacity: disabled ? 0.18 : 1
                                                    }}>
                                                    {ativo && <span style={{ color: 'var(--bg)', fontSize: 11, lineHeight: '16px', display: 'block' }}>✓</span>}
                                                </div>
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            <div className="card flat" style={{ marginTop: 24, padding: '18px 22px' }}>
                <div className="eyebrow" style={{ marginBottom: 8 }}><span className="num">i</span> Como funciona</div>
                <p style={{ fontSize: 12.5, color: 'var(--ink-soft)', lineHeight: 1.7, margin: 0 }}>
                    Cada usuário só vê na sidebar as telas liberadas para seu setor. Telas <strong>TI · Restrito</strong> ficam sempre travadas — só o setor TI as enxerga, independentemente desta matriz. Administradores enxergam tudo. As alterações persistem em <code className="mono">permissoes.json</code> cifrado em AES.
                </p>
            </div>
        </div>
    );
}
